export default __webpack_public_path__ + "static/media/donut-logo.b1e2b1be.png";